// SearchBar.js
import React from 'react';
import { Input } from 'reactstrap';
import { Search } from "react-feather";

const SearchBar = ({ value, onChange, placeholderWhenEmpty, placeholderWhenTyping, size = "sm" }) => {
  const isLg = size === "lg";
  return (
    <div style={{ position: 'relative', width: isLg ? '100%' : '100%' }}>
      <Search
        size={isLg ? 20 : 16}
        strokeWidth={2.5}
        style={{
          position: 'absolute',
          top: '50%',
          left: isLg ? '24px' : '18px',
          transform: 'translateY(-50%)',
          color: value ? '#007bff' : '#495158',
          pointerEvents: 'none',
          transition: 'color 0.2s ease-in-out'
        }}
      />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          paddingLeft: isLg ? '56px' : '42px',
          paddingRight: value ? (isLg ? '80px' : '60px') : (isLg ? '24px' : '20px'),
          backgroundColor: isLg ? '#ffffff' : '#f8f8fb',
          borderRadius: isLg ? '40px' : '30px',
          minHeight: isLg ? '55px' : '45px',
          border: isLg ? '2px solid #e9ecef' : '1px solid #ced4da',
          fontSize: isLg ? '16px' : '14px',
          transition: 'all 0.2s ease-in-out'
        }}
        placeholder={value ? placeholderWhenTyping : placeholderWhenEmpty}
      />
      {value && (
        <button
          onClick={() => onChange("")}
          style={{
            position: 'absolute',
            top: '50%',
            right: isLg ? '20px' : '15px',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            color: '#999',
            fontSize: isLg ? '20px' : '18px',
            cursor: 'pointer',
            width: isLg ? '24px' : '20px',
            height: isLg ? '24px' : '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default SearchBar;



